module.exports = __webpack_public_path__ + "img/bienvenida-fast-2026.9ae3d804.jpg";